import { ProductOperationParams, ProductOperationResponse } from '@repo/accounts-types'
import { Service } from '@repo/core'
import { AxiosRequestConfig } from 'axios'

export const getProductOperations: Service<
  ProductOperationParams,
  ProductOperationResponse,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, accept, config }) => {
  const { accountId, isinId, ...filters } = params

  return api.get<ProductOperationResponse>(
    `/accounts/securities/${accountId}/products/${isinId}/operations`,
    {
      ...(accept && { headers: { Accept: accept }, responseType: 'blob' as const }),
      params: filters,
      ...config,
    },
  )
}
